import Cookies from "js-cookie";
import { calculateGenderAffinityFromCounts } from "./top-affinities";
import { obfuscate } from "../utils/base64-conversions";
export var ProfileCookie = /*#__PURE__*/ function() {
    "use strict";
    function ProfileCookie() {
        this.name = "pers_seg";
    }
    var _proto = ProfileCookie.prototype;
    _proto.setIt = function setIt(profile) {
        var _profile_genderAffinity, _profile, _profile_genderAffinity1, _profile1, _profile_genderAffinity2, _profile2;
        var genderAffinity = calculateGenderAffinityFromCounts({
            all: (_profile = profile) == null ? void 0 : (_profile_genderAffinity = _profile.genderAffinity) == null ? void 0 : _profile_genderAffinity.all,
            men: (_profile1 = profile) == null ? void 0 : (_profile_genderAffinity1 = _profile1.genderAffinity) == null ? void 0 : _profile_genderAffinity1.men,
            women: (_profile2 = profile) == null ? void 0 : (_profile_genderAffinity2 = _profile2.genderAffinity) == null ? void 0 : _profile_genderAffinity2.women
        });
        // This cookie is used to fragment the Akamai cache so be careful not to make this very unique like including the entire profile.
        var value = ProfileCookie.make({
            genderAffinity: genderAffinity
        });
        Cookies.set(this.name, value);
    };
    ProfileCookie.make = function make(param) {
        var genderAffinity = param.genderAffinity;
        // grow the cookie as needed to support personlization of first pixle loading of various pages, this cookie value is passed to SSR.
        var value = {
            genderAffinity: genderAffinity
        };
        return obfuscate(value);
    };
    return ProfileCookie;
}();
